<template>
    <div>
        <v-card flat>
            <v-card-title>
                <v-layout row wrap>
                    <v-flex sm4 xs12>
                        <v-text-field
                            append-icon="search"
                            label="Caută"
                            single-line
                            hide-details
                            v-model="filter"
                        ></v-text-field>
                    </v-flex>
                    <v-flex sm8 xs12 v-if="mode === 'edit'">
                        <v-layout right wrap>
                            <section v-if="selectedItem">
                                <v-btn flat @click="onAction('edit')">Editează</v-btn>
                                <v-btn flat @click="onAction('delete')">Șterge</v-btn>
                            </section>
                            <v-btn color="primary" @click="onAction('add')">Adaugă</v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text class="fixed-header">
              <v-layout row wrap>
                  <v-flex>
                      <tree :data="data" :mode="mode"/>
                  </v-flex>
                  <v-flex v-if="data.length === 0">
                      <p>Nu sunt acțiuni disponibile</p>
                  </v-flex>
              </v-layout>
            </v-card-text>
            <toast-message></toast-message>
            <confirmation-dialog></confirmation-dialog>
        </v-card>
        <v-dialog v-model="editDialog" max-width="500px">
            <v-card>
                <v-card-title>
                  {{ isAddMode ? 'Adaugă' : 'Editează' }} acțiune
                </v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field
                          single-line
                          hide-details
                          v-model="editDialogData.name"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="errorMessageGeneric">
                        <v-alert :value="true" type="error">{{ errorMessageGeneric }}</v-alert>
                    </v-flex>
                    <v-flex xs12 v-if="errorMessages.length">
                        <v-alert :value="true" type="error">{{ errorMessages }}</v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click.native="editDialog = false">Cancel</v-btn>
                    <v-btn color="primary"
                            @click.native="onDialogSave()"
                            :loading="processing"
                            :disabled="processing">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
    </div>
</template>

<script>
import Tree from './Tree.vue';
import bus from '../bus';

export default {
  components: {
    Tree
  },
  props: ['data', 'mode'],
  data() {
    return {
      editDialogData: '',
      editDialog: false,
      processing: false,
      errorMessages: [],
      errorMessageGeneric: null
    };
  },

  computed: {
    selectedItem() {
      return this.$store.state.actions.selectedItem;
    },

    isAddMode() {
      return this.editDialogData.id === null;
    },

    filter: {
      get() {},

      set(value) {
        this.$store.commit('actions/FILTER', value);
      }
    }
  },

  created() {},

  mounted() {
    bus.$on('action', payLoad => {
      this.initErrorMessage();
      if (payLoad.id) {
        this.editDialog = true;
        this.editDialogData = {
          id: payLoad.id,
          name: payLoad.name
        };
      }
    });
  },

  methods: {
    initErrorMessage() {
      this.errorMessages = [];
      this.errorMessageGeneric = null;
    },

    onAction(event) {
      switch (event) {
        case 'add':
          this.initErrorMessage();
          this.editDialog = true;
          this.editDialogData = { id: null, name: '' };
          break;
        case 'duplicate':
          break;
        case 'edit':
          this.initErrorMessage();
          if (this.selectedItem.id) {
            this.editDialog = true;
            this.editDialogData = {
              id: this.selectedItem.id,
              name: this.selectedItem.name
            };
          }
          break;
        case 'delete':
          const deletedItem = this.selectedItem.name;
          bus.$emit('confirmation-dialog-show', {
            title: 'Confirmare ștergere',
            text: `Sunteți sigur că doriți să stergeți acțiunea ${
              this.selectedItem.name
            }?`,
            actionButton: 'Sterge',
            action: () => {
              this.$store
                .dispatch('actions/DELETE', this.selectedItem.id)
                .then(() => {
                  bus.$emit('toast-message-show', {
                    text: `Acțiunea ${deletedItem} a fost ștearsă.`
                  });
                })
                .catch(() => {
                  bus.$emit('toast-message-show', {
                    error: true,
                    text: `A intervenit o eroare la ștergerea acțiunii ${deletedItem}.`
                  });
                });
            }
          });
          break;
        default:
          break;
      }
    },

    onDialogSave() {
      if (this.isAddMode) {
        this.processing = true;
        this.$store
          .dispatch(`actions/ADD`, {
            name: this.editDialogData.name,
            parent_id: this.selectedItem ? this.selectedItem.id : 0
          })
          .then(response => {
            this.processing = false;
            this.editDialog = false;
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.processing = false;
              this.errorMessages = error.response.data.errors;
            } else {
              this.processing = false;
              this.errorMessageGeneric = 'A apărut o eroare la salvare.';
            }
          });
      } else {
        this.processing = true;
        this.$store
          .dispatch(`actions/EDIT`, {
            id: this.selectedItem.id,
            name: this.editDialogData.name,
            parent_id: this.selectedItem.parent_id
          })
          .then(response => {
            this.processing = false;
            this.editDialog = false;
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.processing = false;
              this.errorMessages = error.response.data.errors;
            } else {
              this.processing = false;
              this.errorMessageGeneric = 'A apărut o eroare la salvare.';
            }
          });
      }
    },

    onSelect() {
      this.$store.commit('actions/SELECT', this.node);
    }
  }
};
</script>

<style>
.fixed-header {
  max-height: 70vh;
  overflow: scroll;
}
</style>




// WEBPACK FOOTER //
// src/components/ActionTree.vue